import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      value: null
    };
  },
  methods: {
    openRefundsDetail() {
      if (this.params.context.componentParent.$refs.affiliateDetailModal) {
        this.params.context.componentParent.$refs.affiliateDetailModal.openRefundsDetail(this.params.data.id);
      } else {
        this.params.context.componentParent.openRefundsDetail(this.params.data.id);
      }
    }
  },
  template: `
        <span class="no-underline hover:underline cursor-pointer" v-on:click="openRefundsDetail">
            {{this.params.value}}
        </span>
    `
});
